/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../../resources/taxon';
import '../../../../connect/v2/resources/error';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

const jsonData = {
  "squareup": {
    "nested": {
      "solidshop": {
        "nested": {
          "v2": {
            "nested": {
              "service": {
                "nested": {
                  "ListProductTaxonsRequest": {
                    "fields": {
                      "rootKey": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "depth": {
                        "type": "int32",
                        "id": 2,
                        "rule": "optional",
                        "options": {
                          "default": 0
                        }
                      },
                      "storeCode": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "ListProductTaxonsResponse": {
                    "fields": {
                      "productTaxons": {
                        "type": "squareup.solidshop.v2.resources.ProductTaxon",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "errors": {
                        "type": "squareup.connect.v2.resources.Error",
                        "id": 2,
                        "rule": "repeated"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.solidshop?.nested?.v2?.nested?.service?.nested?.ListProductTaxonsRequest && !$root.nested?.squareup?.nested?.solidshop?.nested?.v2?.nested?.service?.nested?.ListProductTaxonsResponse) {
	$root.addJSON(jsonData);
}

/**
 * SOURCE ListProductTaxonsRequest @ squareup/solidshop/v2/service/taxons/list_product_taxons.proto at 11:1
 */
export const ListProductTaxonsRequest = $root.lookupType('squareup.solidshop.v2.service.ListProductTaxonsRequest');
fixType(ListProductTaxonsRequest);
Builder.createAndAttachToType(ListProductTaxonsRequest);
/**
 * SOURCE ListProductTaxonsResponse @ squareup/solidshop/v2/service/taxons/list_product_taxons.proto at 22:1
 */
export const ListProductTaxonsResponse = $root.lookupType('squareup.solidshop.v2.service.ListProductTaxonsResponse');
fixType(ListProductTaxonsResponse);
Builder.createAndAttachToType(ListProductTaxonsResponse);
